export function SolvedTicketsSvg() {
  return (
    <svg
      width="50"
      height="60"
      viewBox="0 0 60 70"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
    >
      <rect
        x="0.558838"
        y="0.411865"
        width="57.8824"
        height="69.1765"
        fill="url(#pattern0_378_1002)"
      />
      <defs>
        <pattern
          id="pattern0_378_1002"
          patternContentUnits="objectBoundingBox"
          width="1"
          height="1"
        >
          <use
            xlinkHref="#image0_378_1002"
            transform="matrix(0.0111111 0 0 0.00929705 0 0.0816326)"
          />
        </pattern>
        <image
          id="image0_378_1002"
          width="90"
          height="90"
          xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFoAAABaCAYAAAA4qEECAAAACXBIWXMAAAsTAAALEwEAmpwYAAADIUlEQVR4nO2cv2pUQRSHx0UTC7ESVBQstfMZrDSiryBWYpFoqRa+hBA7sfMB9A0s/AOCSROwFgRLTSCm0E8OXmFZ9s7O2b3z954PAiky98zv28lk9ty9cc4wDMMwDMMwDMMwDMNwwEngIfAROKAeDoAPwANgveiXErgI7FI/O5LFFbySW5A8Lbu8ld1tF62x5Uqj25Nb470rDWCf9th3pUGjuNKgUVxp0CiuNGgUVxo0iisNGsWVBvXwC3gEnOu+5Pujvh/25M3TG6EeyRtz5v64b0Bg3nS9ESqVLADn+wa5HrL1RqhU8oCi0/RGKJdDn+Ru7k/6Bivzxu+NUK/kjW7Fz0WZ92cUuQGFc3IE3F4w5+vdi9GLNm8UuSGFa5YsaPNGkRtSuGbJgjZvFLkhhWuWLGjzRpEbUrhmyYI2bxS5IYVrlixo80aRG1J4Dm+B+8Am8IkCjnA+tHmjyA0pPMMrYDI15jjwgkIlC9q8Q3sNLjzDpTnjJkvKji5Z0OYdyqcv1CJ+Ayd6xk6UskMk31xVsqDN62ITOO9rnvGTQNnJJAvavC42gfP+ApxZQfZhSsmCNq+LjWLue3Jnw3OdY8DzJY9wN5Y5wvnQ5nWxUc5fK/soh2RBm9fFZokMe4Gys0kWtHldbJbMsRuwZ19NuSfPos3rYrNClj3fys61kv+jzbuSxMDQpJRNAsmCNu8gMhcEJ5VsEkkWtHkHlaopPLRsEkoWtHmjyA0pPKRsEksWtHmjSvYVXuE0cnbm+rdini7GKlr4DjwF7gIvgT9kYAyii8BEJ8JEJ8JEJ8JEJ8JEJ8JEj1h0i48o/+jJejqn6NE8dA9czilank5qjU3PzYZsote7B2Za4TOw1pN1O5voqX/1s9OI5As9GeVjbF+zip5a2Vuyv1X2B3IfeNd9+HLNk++e7yLJRLcM/04b30x0RLo78q8X/VrEnMNYJD8L2X9yz7X27eJN6Eafe761ruI7i/ZkE60EOAVc6d6MbPuOcFWJruzot1JvJCtj6o1kZUy9kayMqTeSHUbQGykGGu+NGIZhGIZhGIZhGIZhuBHxF889LZ5xGmX5AAAAAElFTkSuQmCC"
        />
      </defs>
    </svg>
  );
}

export function UnsolvedTicketsSvg() {
  return (
    <svg
      width="50"
      height="60"
      viewBox="0 0 60 70"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
    >
      <rect
        x="0.308838"
        y="0.411865"
        width="57.8824"
        height="69.1765"
        fill="url(#pattern0_378_32)"
      />
      <defs>
        <pattern
          id="pattern0_378_32"
          patternContentUnits="objectBoundingBox"
          width="1"
          height="1"
        >
          <use
            xlinkHref="#image0_378_32"
            transform="matrix(0.0111111 0 0 0.00929705 0 0.0816326)"
          />
        </pattern>
        <image
          id="image0_378_32"
          width="90"
          height="90"
          xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFoAAABaCAYAAAA4qEECAAAACXBIWXMAAAsTAAALEwEAmpwYAAADvUlEQVR4nO2czXINQRTHm0U8hI2IWAoPwIIoRFkLSx87PIMSSjwC3oBCEtYhG6F8xCrxACI+SpBYiFJ+6lQ3detW7p2Znp7b03PPr+rW/ZjJzOlTZ/59Ts+ZGKMoiqIoiqIoiqJkA2wDLgHPgB/uJZ8vyrYch1CyALYDb+jMguyTeSAlM5K7ObnV2RrZvmDlIi8XCh5b5egfwPMCjp43OVE5agNYL+DoNZMDlaPeOboyOUoWKpCOquQoabB5ctDoq+IqSR5sZiCpWxayz0DOY6qju2QIC6EKFpWOLki0ijSIZrqIlNdT99tAbDmKTh2LAiqQo6jUuSggsBxFI4WigIByFA0tCnqEzuw9omCuut4ru/rd0d9j25ssKh09opFFQR1pXFHgALYCp4GHwHvgl3ufAU7JdtNrGlMUOICdwOuMwHkl+5le04iiwPx38qecUvgRGIxtc3Jg5SIrktt5GUVGUgaryT6Mx7Y9KYBHno6ejm17UgArno5ejm17UgAbno7+Gdv2pMDmyT68i217UmCLER8exLY9KbAVnw8nq8w3z7sImAbOAVtM4mDHJRVfEV5Ukkc7Y6T+b2emCYk7tjKUii8Pst+OqgyRSO7EWdMAgEFX8WVF8mCsCaMxiTv2yh130rjsUj95nxJNrvzqzXD0VKUn7yfcxNeJM7HtMw27pDaL6ukmZB61QhwqE5/Tqyn3WZ2sKEq/ARwGbgNvW7phl4BbwGhs+5IH2A3Mkc0TYDi2vUkCHABWyY/suz+23SlG8irF+QLsim1/MgCz+DMX2/6UJr6yHIo5AGmiueFuCckCzGQdm2ew2UVZbsYcgDi2nUlTM7ApXFmW6nZzc8Wk3dNdv6Z6JxdBex6AvcA114fd2tUp368CIx7HXKM8a3WTjusl0q+pnIO+X6SYCCQdiybyZDjpItt7MgSOy2MYBQf+DRjri8kwBFgn//YcvPzdsRznGA3g6IMmVbByUTSSN4vsoRznkrULX2ZNymDv0oTgXs473Z/7rgQH9hGOP3myEVkgco4r4uS0F5WwKVxIJnKedxh4nON4s0lHsufzisH/R5KsXUgmIWlbyzM4i+63dCe+doAPgR2tzeGBm8A7sbHpifod/JvAO6HN4XXU6L4BmAjs6Muxx1RLsKt0IfPoPbHHVFuwq3AhuBN7LLUGWzzIWkUZvkZ5GD41gLGSq3dHY48hGYAjLjKLIHdNTsS2PTmAIVmFcxNbN2T7XZWL8g4fcanffNuzJPL9imYXiqIoiqIoiqIopjx/AZN4RA3oKed0AAAAAElFTkSuQmCC"
        />
      </defs>
    </svg>
  );
}

export function AvgResolutionTimeSvg() {
  return (
    <svg
      width="50"
      height="60"
      viewBox="0 0 60 70"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
    >
      <rect
        x="0.0898438"
        y="0.44873"
        width="57.8205"
        height="69.1026"
        fill="url(#pattern0_378_297)"
      />
      <defs>
        <pattern
          id="pattern0_378_297"
          patternContentUnits="objectBoundingBox"
          width="1"
          height="1"
        >
          <use
            xlinkHref="#image0_378_297"
            transform="matrix(0.0111111 0 0 0.00929705 0 0.0816327)"
          />
        </pattern>
        <image
          id="image0_378_297"
          width="90"
          height="90"
          xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFoAAABaCAYAAAA4qEECAAAACXBIWXMAAAsTAAALEwEAmpwYAAAEf0lEQVR4nO2cx24WMRRGRwTR1oASYBEIa1hSFjRBIEhs6XskmkSRgC28QyhiQ30Gajb0FtiQRDxCCAuKRGDBQdYYKQrTPHM99njmSL8UJeN/vu9iPL72HUdRAwC2AteAceCH/qifrwJbXOtrPMAA8Jh8HgIrXettJMBGYIrifAY2uNbdKIB+YBJz1D/MgGv9jQF4RHlGXOtvBMA2qtM9IPPQs4skfgKngF6gDzitf5fEldwbtR1gIiV4pxKuPZNy7Zgb9Q0C+J4SvN6Ea1XvTuJbFDoJyYUUfQn3UkOIFM1IggySi7KcTrjnWezhXxJUIrkow0/9AOzTHzU+T2MXf5KgCslFU/AjCaqYXDSFkRCSi6awxevkosQ0ziap0z6vkyCT5GI2wCvq50UBXf4lQaqHpIjqLdD2JPVzvICuPu+SoDQ3BdvOBz5QH++BebZ9WaGqIGBFTcFWQV5ely9xJAQR9+wTavwUfkCq73quhouiPVnSlyjeCQrVl3eCQvXlnaBQfXknKFRf3gkK1Zd3gkL15Z2gUH15JyhUX94JCtWXbUHAauAYcBcYBb4Av/VnSv9O/e2o5C5IKwINzAUO6fTZlGfAQaDHN1+RT4KAXcAnqqPWyQd98VUZKUHAIuA68qgdoIWufIkhIQhYCrzDHm+AJXX7EqWqIOIgp22HSTJhEuyqvsSpIoh4uLDZk5N69gLbvqxQRRB2xuQ8Cu1kpzWOXFFWEDCIO4Zs+bJGGUHE82SJKVxZxvPm2WkNI1eUEQQcxj37pX1ZpYwg4k1Y1zyV9mUVU0HEaxfSqNLdc7r6v1f//CunzZ+s2ue0RpErTAURL/5IB/m/hxtwvkDbI1K+rGMqiHilzWqQDV65uC3lyzqmgogrhiRQQ8OejPssK/Adb6V8WcdUEDKvX6T25Bn3uVDgeyalfFnHVBD5DynFTWAdsBa4qBf5TYI8VPDdlmkpX00M9I2ENjt1cXjmcDHrWtoe6Kkc8+syeqlUT27F0DGaY35NSR2mQQ7+YXgnx/ylmoKsuCXlq4kJy29gdw1BDj5hGdDpbxbTRYJdMchKQ7+UL+uUEUSxMoK8hMRkdpHEE2lfVikjiLjugrLBFgiyYq+0L6uUEQT0GGzITusFon8v2p8XeNH+YysW/hXADtyxLcohrWHkiiqCSH+92SbDtn1ZoYogYKEuAaiLl60sN1CoopaaCmjUhuziqCZf4kgIIg72a8s9ud0lYbOGkSsWgjxcdLhoRaD/AWzX/80RmMLlzi5aG+gZ8+wDqiSgQLo+E3XtE2AfMCeqQCsCPRNVEqAWf9RGqi6InNIZ4y99gtdb/bcjWWsXprQu0K7wzpd3gkL15Z2gUH15JyhUX94JCtWXd4JC9VXlODZfySgn++pS1ETRI4ibQsZRyU4PGFSHWmceQRw1BPKPSr7s+vTztrDJWaB1sB8QPvecBrlFB3WvinxAHc+uF3lCYxJYH/mEXmkLaRi5L7kiKA6wWe+WjDk6jLss3/WGwWXnD76Ojo6Ojo6Ojo6Ojo6oRv4Cj2EXLIizVdEAAAAASUVORK5CYII="
        />
      </defs>
    </svg>
  );
}

export function AvgResponseTimeSvg() {
  return (
    <svg
      width="41"
      height="49"
      viewBox="0 0 41 49"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M36.8938 16.1889L39.2257 13.8703C39.7082 13.3852 39.9793 12.7273 39.9793 12.0412C39.9793 11.3552 39.7082 10.6973 39.2257 10.2122C38.7432 9.72706 38.0887 9.45453 37.4063 9.45453C36.7239 9.45453 36.0695 9.72706 35.5869 10.2122L33.2807 12.5565C29.6895 9.76353 25.2776 8.24818 20.7373 8.24818C16.1969 8.24818 11.785 9.76353 8.19382 12.5565L5.86194 10.1864C5.37602 9.7013 4.71831 9.43013 4.03351 9.43254C3.34871 9.43496 2.69291 9.71076 2.21038 10.1993C1.72785 10.6878 1.45812 11.349 1.46052 12.0375C1.46293 12.7259 1.73727 13.3852 2.22319 13.8703L4.58069 16.2146C1.76967 19.815 0.244406 24.2609 0.250067 28.8379C0.241699 32.1236 1.01488 35.3637 2.50513 38.2879C3.99538 41.2122 6.15949 43.7359 8.81699 45.6485C11.4745 47.5611 14.5484 48.8072 17.7822 49.2829C21.0161 49.7586 24.3162 49.45 27.4073 48.383C30.4985 47.316 33.291 45.5214 35.5522 43.1489C37.8133 40.7764 39.4774 37.8948 40.4057 34.7445C41.334 31.5941 41.4996 28.2662 40.8887 25.0384C40.2778 21.8106 38.9081 18.7764 36.8938 16.1889ZM20.7501 44.2949C17.7092 44.2949 14.7366 43.3884 12.2082 41.6899C9.67977 39.9915 7.70912 37.5774 6.54542 34.753C5.38172 31.9286 5.07725 28.8207 5.67049 25.8224C6.26374 22.824 7.72807 20.0698 9.8783 17.9081C12.0285 15.7464 14.7681 14.2743 17.7506 13.6779C20.733 13.0814 23.8244 13.3875 26.6338 14.5574C29.4432 15.7274 31.8445 17.7085 33.5339 20.2504C35.2233 22.7923 36.1251 25.7808 36.1251 28.8379C36.1251 32.9373 34.5052 36.8689 31.6218 39.7676C28.7385 42.6664 24.8278 44.2949 20.7501 44.2949ZM15.6251 5.65234H25.8751C26.5547 5.65234 27.2065 5.38092 27.687 4.8978C28.1676 4.41467 28.4376 3.75941 28.4376 3.07617C28.4376 2.39293 28.1676 1.73767 27.687 1.25454C27.2065 0.771417 26.5547 0.5 25.8751 0.5H15.6251C14.9454 0.5 14.2937 0.771417 13.8131 1.25454C13.3325 1.73767 13.0626 2.39293 13.0626 3.07617C13.0626 3.75941 13.3325 4.41467 13.8131 4.8978C14.2937 5.38092 14.9454 5.65234 15.6251 5.65234ZM23.3126 21.1094C23.3126 20.4261 23.0426 19.7709 22.562 19.2877C22.0815 18.8046 21.4297 18.5332 20.7501 18.5332C20.0705 18.5332 19.4187 18.8046 18.9381 19.2877C18.4575 19.7709 18.1876 20.4261 18.1876 21.1094V25.9783C17.6073 26.5001 17.1984 27.1866 17.0148 27.9471C16.8312 28.7077 16.8816 29.5063 17.1593 30.2374C17.4371 30.9685 17.9291 31.5976 18.5703 32.0414C19.2115 32.4852 19.9716 32.7228 20.7501 32.7228C21.5285 32.7228 22.2886 32.4852 22.9298 32.0414C23.571 31.5976 24.063 30.9685 24.3408 30.2374C24.6186 29.5063 24.669 28.7077 24.4854 27.9471C24.3018 27.1866 23.8928 26.5001 23.3126 25.9783V21.1094Z"
        fill="white"
      />
    </svg>
  );
}
